import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../constants/common'
import { SearchListItem } from '../SearchListItem'

import * as styles from './SearchListItems.module.css'

/**
 * @import {SearchListItemProps} from "../SearchListItem/SearchListItem"
 */

/**
 * @typedef {object} SearchListItemsProps
 *
 * @property {string} [Element]
 *
 * @property {React.ComponentType<SearchListItemProps>} [Item]
 *
 * @property {string} [className]
 *
 * @property {SearchListItemProps} itemProps
 *
 * @property {SearchListValue} value
 *
 * @property {(value: SearchItemValue) => void} [onSelect]
 */

/**
 * @param {SearchListItemsProps} props
 */
function SearchListItems({
  Element = 'ul',
  Item = SearchListItem,
  className = styles.SearchListItems,
  itemProps: {
    className: itemClassName = styles.item,
    ...itemProps
  } = EMPTY_OBJECT,
  value,
  onSelect = EMPTY_FUNCTION,
  ...elementProps
}) {
  const { config, items, search } = value

  return (
    <Element {...elementProps} className={className}>
      {items.map((item, index) => (
        <Item
          {...itemProps}
          className={itemClassName}
          key={item.id ?? index}
          value={{ item, search }}
          onSelect={onSelect}
        >
          <config.Component value={{ item, search }} />
        </Item>
      ))}
    </Element>
  )
}

export default SearchListItems
